'use strict';
var table = document.querySelector('.field');
var appendRow = document.querySelector('.append-row');
var removeRow = document.querySelector('.remove-row');
var appendColumn = document.querySelector('.append-column');
var removeColumn = document.querySelector('.remove-column');
appendRow.addEventListener('click', function(e) {
    if (table.tBodies[0].rows.length < 10) {
        var newRow = document.createElement('tr');
        for(var i = 0; i < table.rows[0].cells.length; i++){
            var newCell = document.createElement('td');
            newRow.appendChild(newCell);
        }
        table.tBodies[0].appendChild(newRow);
    }
    if (table.tBodies[0].rows.length === 10) e.target.disabled = true;
    else removeRow.disabled = false;
});
removeRow.addEventListener('click', function(e) {
    if (table.tBodies[0].rows.length > 2) table.tBodies[0].deleteRow(-1);
    if (table.tBodies[0].rows.length <= 2) e.target.disabled = true;
    else appendRow.disabled = false;
});
appendColumn.addEventListener('click', function(e) {
    if (table.rows[0].cells.length < 10) {
        var rows = Array.from(table.tBodies[0].querySelectorAll('tr'));
        rows.forEach(function(row) {
            var newCell = document.createElement('td');
            row.appendChild(newCell);
        });
    }
    if (table.rows[0].cells.length === 10) e.target.disabled = true;
    else removeColumn.disabled = false;
});
removeColumn.addEventListener('click', function(e) {
    if (table.rows[0].cells.length > 2) {
        var rows = Array.from(table.tBodies[0].querySelectorAll('tr'));
        rows.forEach(function(row) {
            row.deleteCell(-1);
        });
    }
    if (table.rows[0].cells.length === 2) e.target.disabled = true;
    else appendColumn.disabled = false;
});

//# sourceMappingURL=js_growth_table_DOM.a6a9b48b.js.map
